import { render, staticRenderFns } from "./policy-edit.vue?vue&type=template&id=484a1ece&"
import script from "./policy-edit.vue?vue&type=script&lang=js&"
export * from "./policy-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports